/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { Alert } from '../../shared/alert/alert';

export interface TT2CMultiPendingAlertProps {
  numberOfPendingT2CAuthContacts: number;
  numberOfContacts: number;
  onClickResend: () => void;
}

export const T2CMultiPendingAlert = ({
  numberOfPendingT2CAuthContacts,
  numberOfContacts,
  onClickResend,
}: TT2CMultiPendingAlertProps) => {
  return (
    <Alert status="info">
      <div className="sui-grid sui-justify-items-start sui-gap-4">
        <Typography variant="body-base">
          {numberOfPendingT2CAuthContacts} of {numberOfContacts} Text2Confirm
          Invites Pending Acceptance
        </Typography>
        <Link component="button" onClick={onClickResend}>
          Resend Invites
        </Link>
      </div>
    </Alert>
  );
};
